import { useTheme } from '@/lib/theme'
import { useI18n } from '@/lib/i18n'
import { Moon, Sun } from 'lucide-react'
import { useEffect, useState } from 'react'
import './ThemeSwitcher.css'

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme()
  const { t } = useI18n()
  // The prerendered HTML is built in light mode; show the stored/system
  // theme only after hydration so the first client render matches it.
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  const isLight = !mounted || theme === 'light'
  const next = isLight ? 'dark' : 'light'
  const label = `${t('nav.theme')}: ${t(`nav.${next}`)}`

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(next)}
      aria-label={label}
      title={label}
      aria-pressed={!isLight}
    >
      {isLight ? <Moon size={15} strokeWidth={1.75} /> : <Sun size={15} strokeWidth={1.75} />}
    </button>
  )
}
